<template>
    <div>
        <button class="btn" :class="isDisabled ? 'button-disabled' : 'button-yellow'" @click="onClick()">
            <slot></slot>
        </button>
    </div>
</template>

<script>
export default {
    name: 'YellowButton',
     props:{
        isDisabled: { type:Boolean , default: false}
    },
    data() {
        return {

        };
    },

    mounted() {

    },

    methods: {
        onClick: function(){
            this.$emit('onClick');
        }
    },
};
</script>

<style lang="scss" scoped>
@import '@/style/base/baseUtility.scss';
@import '@/style/base/base.scss';
.btn{
    width: 100%;
    height: 45px;
    flex-grow: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 9px 10px;
    border-radius: 10px;
    border: 0;
    margin: auto;
    font-size: 16px;
    font-family: $ff-reg;
    @include mobile{
        font-size: 16px;
    }
    &.button-yellow {
        background-color: $a-orange-f8a51b;
        color: white;
    }
    &.button-disabled {
        color:#333333;
        background-color: #cdcdcd;
    }
}
.btn:hover {
    color: none;
}
</style>
